import { enableModernMyCarsFlag } from '../global-constants';

export const useFooterLayoutClasses = (
	flags,
	isDesktop,
	isTabbedLayout,
	shouldFullyRenderCard
) => {
	const enableModernMyCars = flags[enableModernMyCarsFlag];
	return [
		'vehicle-card-footer',
		'd-flex',
		'align-items-center',
		enableModernMyCars ? 'gap-2-rem border-top-0' : '',
		enableModernMyCars && isTabbedLayout ? '' : 'flex-wrap',
		enableModernMyCars && isTabbedLayout && isDesktop
			? 'justify-content-between'
			: 'justify-content-around',
		enableModernMyCars &&
		isDesktop &&
		!isTabbedLayout &&
		!shouldFullyRenderCard
			? 'mx-4'
			: ''
	];
};
